import React, { useEffect, useState } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { xcss } from '@atlaskit/primitives';

import { getColorFromString } from '../../../utils/header-gradient';
import { FallbackGradient } from '../fallback-gradient';

import * as Styled from './styled';

interface Props {
	teamId: string;
	avatarUrl?: string;
}

const fallbackStyle = xcss({
	width: '24px',
	height: '24px',
	borderRadius: '50%',
	margin: 'space.025',
});

export const TeamAvatar = ({ avatarUrl, teamId }: Props) => {
	const [hasError, setError] = useState(false);
	const [hasLoaded, setLoaded] = useState(false);

	useEffect(() => {
		setError(false);
		setLoaded(false);
	}, [avatarUrl, teamId]);

	if (hasError) {
		return fg('use_consistent_default_gradient_component') ? (
			<FallbackGradient stringToHash={teamId} customStyles={fallbackStyle} />
		) : (
			<Styled.GradientImage gradientValues={getColorFromString(teamId)} />
		);
	}

	return (
		<Styled.Image
			src={avatarUrl}
			onError={() => setError(true)}
			onLoad={() => setLoaded(true)}
			hasLoaded={hasLoaded}
			alt=""
		/>
	);
};
